/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sanction_ExpiresInputs */



/**
* | output |
* | --- |
* | "Expires: {date}" |
*
* @param {Sanction_ExpiresInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_expires = /** @type {((inputs: Sanction_ExpiresInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_ExpiresInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Expire le : ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Expira: ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Expira: ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Scade: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Expires: ${i?.date}`)
});